import { render, staticRenderFns } from "./ProfileTrlData.vue?vue&type=template&id=1ad8bb2a&scoped=true&"
import script from "./ProfileTrlData.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileTrlData.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8bb2a",
  null
  
)

export default component.exports